angular
  .module('components')

  .factory('ServiceCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class ServiceCrud extends Crud {
        constructor(list) {
          super(
            'service' + (list || ''),
            '@@apiUrl' + '/services' + (list || '') + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }

      return ServiceCrud;
    }
  ]);
